import { D as r } from "../DatePicker-yNjER0Ih.es.js";
import { S as o } from "../SimpleDatePicker-U_TKYKJp.es.js";
import { P as p } from "../PresetDatePicker-CpaQulJl.es.js";
import { d as t, m as a } from "../propTypes-DVvgo52A.es.js";
const e = r;
e.dayPropType = t;
e.monthPropType = a;
e.Simple = o;
e.Preset = p;
export {
  e as default
};
